var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "preview-class",
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      title: _vm.$t("文件列表")
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      "file-list": _vm.fileList,
      "list-type": "picture-card",
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: false,
        showDownloadIcon: _vm.download ? true : false
      }
    },
    on: {
      preview: _vm.handlePreview,
      download: _vm.handleDownload
    }
  }), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible2,
      videoTypeList: ["avi", "mov", "rm", "mp4", "rmvb"],
      fileList: _vm.fileList,
      show: _vm.isShow,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible2 = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };